import { RouteRecordRaw } from 'vue-router';
import applicationsRoutes from './applicationsRoutes';
import providerApplicationsPageRoutes from './providerApplicationsPageRoutes';
import profileRoutes from './profileRoutes';
import providersDashboardRoutes from './providersDashboard';
import availabilityRoutes from './availabilityRoutes';
import bookingsRoutes from './bookingsRoutes';
import jobSearchRoutes from './jobSearchRoutes';
import reviewRoutes from './reviewRoutes';
import sitterOnboardingRoutes from './sitterOnboardingRoutes';
import backupCareInviteRoutes from './backupCareInviteRoutes';

const providerRoutes = [
  ...applicationsRoutes,
  ...providerApplicationsPageRoutes,
  ...profileRoutes,
  ...providersDashboardRoutes,
  ...availabilityRoutes,
  ...bookingsRoutes,
  ...jobSearchRoutes,
  ...reviewRoutes,
  ...sitterOnboardingRoutes,
  ...backupCareInviteRoutes,
] as RouteRecordRaw[];

export default providerRoutes;
